(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || preference.matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sosanova-reveal-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  const register = () => {
    document.querySelectorAll('.card__media img, .product__media img, .banner__media img, .image-with-text__media img').forEach(img => {
      if (img.dataset.sosanovaReveal || img.closest('.scroll-trigger')) return;
      img.dataset.sosanovaReveal = 'true';
      const ready = () => {
        if (!img.naturalWidth || preference.matches) return;
        img.classList.add('sosanova-reveal-ready');
        observer.observe(img);
      };
      if (img.complete) ready();
      else img.addEventListener('load', ready, { once: true });
    });
  };
  register();
  document.addEventListener('shopify:section:load', register);
  preference.addEventListener('change', event => {
    if (!event.matches) return;
    observer.disconnect();
    document.querySelectorAll('.sosanova-reveal-ready').forEach(img => img.classList.add('sosanova-reveal-visible'));
  });
})();